import { httpsCallable } from 'firebase/functions';
import { ExternalCalendar } from 'shared/types/external-calendar';
import { ID } from 'shared/types/id';

import { getFunctions } from './helpers';

export const getExternalConnectionCalendars = async (
  externalConnectionId: ID,
) => {
  const functions = getFunctions();
  const fetchEvents = httpsCallable<
    { externalConnectionId: ID },
    ExternalCalendar[]
  >(functions, 'externalConnections-getCalendars');

  const { data } = await fetchEvents({ externalConnectionId });
  return data;
};
